import React from "react";
import { CardContainer, Full, OrderedFlexBox } from "./styled-datafetcher";
import { FlexBox } from "../../styles/global";
import { useDataContext } from "../../context/DataContext";
import ReactLoading from "react-loading";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DetalhadoModal from "./DetalhadoModal";
// import Quadro from "./Quadro";
import NovoQuadro from "./NovoQuadro";

const DataFetcher: React.FC = () => {
  const {
    tempoMedio7dias,
    selectedEspecialidades,
    setSelectedEspecialidade,
    selectedHospital,
    setSelectedHospital,
    loading,
    metricasEspecialidades,
    especialidades,
    // listOptinsEspecialidades,
    macrorregiaoColorMap,
    especialidadesColorMap,
    isSmallScreen,
  } = useDataContext();

  const [expanded, setExpanded] = React.useState<string | false>(
    "especialidades"
  );
  const [selectedOption, setSelectedOption] = React.useState(
    selectedEspecialidades
  );
  const [selectedHospitalOption, setSelectedHospitalOption] =
    React.useState(selectedHospital);

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [modalHospital, setModalHospital] = React.useState("");
  const [modalEspecialidade, setModalEspecialidade] = React.useState("");
  // const [isHovered, setIsHovered] = React.useState(false);

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(
        newExpanded
          ? panel
          : panel !== "hospitais"
          ? "hospitais"
          : "especialidades"
      );
    };

  const handleEspecialidadeChange = (
    event: React.MouseEvent<HTMLElement>,
    especialidade: string
  ) => {
    if (especialidade) {
      setSelectedOption(especialidade);
      setSelectedEspecialidade(especialidade);
      setSelectedHospitalOption("Todos");
      setSelectedHospital("Todos");
    }
  };

  const handleHospitalChange = (
    event: React.MouseEvent<HTMLElement>,
    hospital: string
  ) => {
    if (hospital) {
      setSelectedHospitalOption(hospital);
      setSelectedHospital(hospital);
      setSelectedOption("Todas");
    }
  };

  const handleHospitalSelectChange = (event: SelectChangeEvent) => {
    const hospital = event.target.value;

    if (hospital) {
      setSelectedHospitalOption(hospital);
      setSelectedHospital(hospital);
      setSelectedOption("Todas");
    }
  };

  const handleEspecialidadeSelectChange = (event: SelectChangeEvent) => {
    const especialidade = event.target.value;

    if (especialidade) {
      setSelectedOption(especialidade);
      setSelectedEspecialidade(especialidade);
      setSelectedHospitalOption("Todos");
      setSelectedHospital("Todos");
    }
  };

  // Definindo a sequência desejada
  const hospitalOrder = [
    "HRT",
    "HRSam",
    "HRC",
    "HRBz",
    "HSVP",
    "HRG",
    "HRGu",
    "HRAN",
    "HMIB",
    "HRS",
    "HRL",
    "HRPL",
  ];

  const hospitalsList = [
    // "Todos",
    "HRT",
    "HRSam",
    "HRC",
    "HRBz",
    "HSVP",
    "HRG",
    "HRGu",
    "HRAN",
    "HMIB",
    "HRS",
    "HRL",
    "HRPL",
  ];

  function getMetricas(
    hospital: any,
    metrica: string,
    especialidade: any,
    ultimaSemana: boolean = false
  ) {
    const current = especialidade || selectedEspecialidades;
    let valor;
    if (!ultimaSemana) {
      valor = metricasEspecialidades[hospital]?.[current]?.[0]?.[metrica];
    } else {
      if (tempoMedio7dias[hospital]?.[current]?.length === 1) {
        valor = tempoMedio7dias[hospital]?.[current]?.[0]?.[metrica];
      } else if (tempoMedio7dias[hospital]?.[current]?.length === 2) {
        if (
          tempoMedio7dias[hospital]?.[current]?.[0]
            ?.pacientes_aguardando_atendimento === 0 &&
          tempoMedio7dias[hospital]?.[current]?.[1]
            ?.pacientes_aguardando_atendimento === 0
        ) {
          valor = "!";
        } else if (
          tempoMedio7dias[hospital]?.[current]?.[0]
            ?.pacientes_aguardando_atendimento !== 0
        ) {
          valor = tempoMedio7dias[hospital]?.[current]?.[0]?.[metrica];
        } else {
          valor = tempoMedio7dias[hospital]?.[current]?.[1]?.[metrica];
        }
      } else {
        valor = "?";
      }
    }
    return valor || 0;
  }

  function verificaHospital(hospital: any, item: any) {
    return [
      "pacientes_desistentes",
      "tempo_atendimento",
      "gae_abertas",
      "pacientes_aguardando_atendimento",
    ].some((metrica) => getMetricas(hospital, metrica, item));
  }

  const openModal = (hospital: string, especialidade: string) => {
    setModalHospital(hospital);
    setModalEspecialidade(especialidade);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalHospital("");
    setModalEspecialidade("");
  };

  const especialidadeComFila = Array.from(
    new Set(
      hospitalOrder.flatMap((hospital) =>
        especialidades.filter(
          (especialidade) =>
            metricasEspecialidades[hospital]?.hasOwnProperty(especialidade) &&
            especialidadesColorMap.hasOwnProperty(especialidade)
        )
      )
    )
  );

  // console.log(todasEspecialidades);
  // console.log(listOptinsEspecialidades);

  if (loading)
    return (
      <Full>
        <ReactLoading
          type={"spinningBubbles"}
          color="#fff"
          height={200}
          width={200}
        />
      </Full>
    );

  return (
    <div>
      {isSmallScreen && (
        <OrderedFlexBox
          style={{
            width: "unset",
            minWidth: "315px",
            height: "100%",
            backgroundColor: "white",
            margin: "8px 16px 0 16px",
            borderRadius: "8px",
            border: "6px solid gray",
            borderTopWidth: "12px",
            marginTop: "16px",
            paddingBottom: "16px",
          }}
        >
          {/* SELECT HOSPITAL */}
          <Box sx={{ padding: "16px 16px 0px 16px", width: "50%" }}>
            <FormControl fullWidth size="small">
              <InputLabel id="hospital-label">Hospital</InputLabel>
              <Select
                labelId="hospital-label"
                value={selectedHospitalOption}
                label="Hospital"
                onChange={handleHospitalSelectChange}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Chip
                      size="small"
                      label={selected}
                      sx={{
                        backgroundColor:
                          macrorregiaoColorMap[selected] || "gray",
                        color: "white",
                      }}
                    />
                  </Box>
                )}
              >
                {hospitalsList.map((option) => (
                  <MenuItem key={option} value={option}>
                    <span
                      style={{
                        borderLeft: "solid 4px " + macrorregiaoColorMap[option],
                        paddingLeft: "10px",
                        width: "100%",
                        display: "block",
                      }}
                    >
                      {option}
                    </span>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {/* SELECT ESPECIALIDADE */}
          <Box sx={{ padding: "16px 16px 0px 16px", width: "50%" }}>
            <FormControl fullWidth size="small">
              <InputLabel id="especialidade-label">Especialidade</InputLabel>
              <Select
                labelId="especialidade-label"
                value={selectedOption}
                label="Especialidade"
                onChange={handleEspecialidadeSelectChange}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Chip
                      size="small"
                      label={selected}
                      sx={{
                        backgroundColor:
                          especialidadesColorMap[selected] || "gray",
                        color: "white",
                      }}
                    />
                  </Box>
                )}
              >
                {especialidadeComFila.map(
                  (option) =>
                    especialidadesColorMap[option] && (
                      <MenuItem key={option} value={option}>
                        <span
                          style={{
                            borderLeft:
                              "solid 4px " + especialidadesColorMap[option],
                            paddingLeft: "10px",
                            width: "100%",
                            display: "block",
                          }}
                        >
                          {option}
                        </span>
                      </MenuItem>
                    )
                )}
              </Select>
            </FormControl>
          </Box>
        </OrderedFlexBox>
      )}
      <FlexBox>
        <CardContainer>
          {selectedHospital === "Todos"
            ? hospitalOrder.map(
                (item: any, index: number) =>
                  verificaHospital(item, null) && (
                    <NovoQuadro
                      key={index}
                      hospital={item}
                      item={null}
                      openModal={openModal}
                      getMetricas={getMetricas}
                    />
                    // {quadro(item, null)}
                  )
              )
            : especialidades
                .filter(
                  (especialidade) =>
                    metricasEspecialidades[selectedHospital]?.hasOwnProperty(
                      especialidade
                    ) && especialidadesColorMap.hasOwnProperty(especialidade)
                )
                .map(
                  (especialidade: any, index: number) =>
                    verificaHospital(selectedHospital, especialidade) && (
                      <NovoQuadro
                        key={index}
                        hospital={selectedHospital}
                        item={especialidade}
                        openModal={openModal}
                        getMetricas={getMetricas}
                      />
                      // {quadro(selectedHospital, especialidade)}
                    )
                )}
        </CardContainer>
        {!isSmallScreen && (
          <OrderedFlexBox
            direction="column"
            style={{
              width: "unset",
              minWidth: "315px",
              height: "100%",
              backgroundColor: "white",
              margin: "0 16px 16px 0",
              borderRadius: "8px",
              border: "6px solid gray",
              marginTop: "16px",
            }}
          >
            <Typography
              style={{
                backgroundColor: "gray",
                color: "white",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Selecione:
            </Typography>
            <Accordion
              expanded={expanded === "hospitais"}
              onChange={handleAccordionChange("hospitais")}
              style={{
                boxShadow: "unset",
                marginBottom: 0,
                borderBottom: "2px solid gray",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="hospitais-content"
                id="hospitais-header"
                style={{
                  margin: 0,
                }}
              >
                <Typography component="div">
                  Hospital
                  {expanded === "especialidades" && (
                    <Chip
                      sx={{
                        backgroundColor:
                          macrorregiaoColorMap[selectedHospitalOption] ||
                          "gray",
                        color: "white",
                        position: "relative",
                        top: "-1px",
                        left: "5px",
                      }}
                      label={selectedHospitalOption}
                    />
                  )}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ToggleButtonGroup
                  orientation="vertical"
                  value={selectedHospitalOption}
                  exclusive
                  onChange={handleHospitalChange}
                  style={{
                    width: "100%",
                  }}
                >
                  {hospitalsList.map((option) => (
                    <ToggleButton
                      key={option}
                      value={option}
                      aria-label={option}
                    >
                      <p
                        style={{
                          borderLeft:
                            "solid 2px " + macrorregiaoColorMap[option],
                          paddingLeft: "10px",
                          width: "100%",
                        }}
                      >
                        {option}
                      </p>
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "especialidades"}
              onChange={handleAccordionChange("especialidades")}
              style={{
                marginTop: 0,
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="especialidades-content"
                id="especialidades-header"
              >
                <Typography component="div">
                  Especialidade
                  {expanded === "hospitais" && (
                    <Chip
                      sx={{
                        backgroundColor:
                          especialidadesColorMap[selectedOption] || "gray",
                        color: "white",
                        position: "relative",
                        top: "-1px",
                        left: "5px",
                        marginRight: "10px",
                      }}
                      label={selectedOption}
                    />
                  )}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ToggleButtonGroup
                  orientation="vertical"
                  value={selectedOption}
                  exclusive
                  onChange={handleEspecialidadeChange}
                  style={{
                    width: "100%",
                  }}
                >
                  {/* {listOptinsEspecialidades.map( */}
                  {especialidadeComFila.map(
                    (option) =>
                      especialidadesColorMap[option] && (
                        <ToggleButton
                          key={option}
                          value={option}
                          aria-label={option}
                          // sx={{
                          //   backgroundColor:
                          //     especialidadesColorMap[option] || "#cccccc",
                          //   color: especialidadesColorMap[option],
                          //   "&.Mui-selected": {
                          //     backgroundColor: "blue",
                          //     color: "white",
                          //   },
                          // }}
                        >
                          <p
                            style={{
                              borderLeft:
                                "solid 2px " + especialidadesColorMap[option],
                              paddingLeft: "10px",
                              width: "100%",
                            }}
                          >
                            {option}
                          </p>
                        </ToggleButton>
                      )
                  )}
                </ToggleButtonGroup>
              </AccordionDetails>
            </Accordion>
          </OrderedFlexBox>
        )}
      </FlexBox>
      <DetalhadoModal
        open={isModalOpen}
        onClose={closeModal}
        hospital={modalHospital}
        especialidade={modalEspecialidade}
      />
    </div>
  );
};

export default DataFetcher;
